import { useEffect, useState } from "react";
import sanityClient from "../sanityClient";

export interface CmsQuery {
    docType?: string,
    docId?: string,
    fields?: string,
    additonalQueryString?: string,
    language?: ("de"|"en")
}

export function useCmsData<T extends Object>(cmsQuery: CmsQuery) : readonly[T | undefined, boolean | undefined, string | undefined] {

    const [data, setData] = useState(undefined as T | undefined);
    const [loading, setLoading] = useState(undefined as boolean | undefined);
    const [error, setError] = useState(undefined as string | undefined);

    const {docId, docType, language, additonalQueryString, fields} = cmsQuery;

	useEffect(() => {
        if(!data && !loading) {
            setLoading(true);
            setError(undefined);
            sanityClient
                .fetch(`*[${
                    docType ? 
                        `_type == '${docType}' ` 
                        : (docId ? 
                            `_id == '${docId}' ` 
                            : '')
                    }${language ? ` && language == '${language}' ` : ''}${additonalQueryString ? ` ${additonalQueryString}` : ''}]${fields ? `{${fields}}` : ''} | order(_createdDate desc)`)
                .then((data) => setData(data))
                .catch((e) => setError(e))
                .finally(() => setLoading(false));
        }
	}, [docId, docType, language, additonalQueryString, fields, loading, error, data]);

    return [data, loading, error] as const;
}